import { Dialog, DialogContent, DialogTitle, DialogActions } from '@material-ui/core';
import { Box, Grid, Typography, Card } from '@material-ui/core';
import { useEffect, useRef, useState, useContext, useMemo } from 'react';
import Styles from '../generate-cards/GenerateCards.style';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Tag from '../generate-cards/Tag.component';
import { CustomTemplateModal } from './CustomTemplateModal';
import addIcon from '../../../assets/svgs/addIcon.svg';
import personIcon from '../../../assets/svgs/person.svg';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { IconButton } from '@material-ui/core';
import { MenuItemsList } from './Components/MenuItemsList.component';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import renameIcon from 'assets/svgs/rename.svg';
import {
	EDIT,
	RENAME,
	DELETE,
	CUSTOM_DATASET_ID,
	CUSTOM_DATASET_DEFAULT_DESC,
	CUSTOM_DATASET_DEFAULT_TITLE,
	CUSTOM_CREATOR_PLACEHOLDER,
	ABC,
	CDTourFlag,
	DELETE_SUCCESSFUL
} from 'constants/constant';
import { useSelector, useDispatch } from 'react-redux';
import {
	setSelectedTemplate,
	resetSubTempates,
	getTempatesSuccess,
	// deleteCustomDataset,
	setCustomDatasetName,
	updateCustomDataset,
	resetCustomDatasetDeleteSuccess
} from '../Template.actions';
import {
	saveItemShareStatus,
	setSelectedList,
	setFilterList,
	clearPreview,
	resetDraft,
	setPrevFilterList
} from '../../Preview/Preview.actions';
import { handleBuildReport } from '../quick-report/QuickReport.utils';
import { UserPortalContext } from 'context/appcontext';
import { useNavigate } from 'react-router-dom';
import SaveDatasetModel from './Components/SaveDatasetModal';
import { isUnsavedCustomDataset, isCustomDatasetModular } from 'helper/utils';
import { deepClone } from 'helper/helper';
import FtUXInitBox from './ftux';
import { DeleteDatasetModal } from './Components/DeleteDatasetModal';
import { trackEventInfo } from 'helper/analytics';
import RBSnackbar from 'components/Shared/RBSnackbar';
import { PAGE_ID, EVENTS, ACTION_ON } from 'constants/tracker';

const CUSTOM_TEMPLATE_CARD_OPTIONS_LIST = [
	{
		disabled: false,
		name: `${EDIT}`,
		icon: <EditIcon />,
		id: 'edit'
	},
	{
		disabled: false,
		name: RENAME,
		icon: (
			<div>
				<img src={renameIcon} alt="article-icon" />
			</div>
		),
		divider: true,
		id: 'rename'
	},
	{
		disabled: false,
		name: DELETE,
		icon: <DeleteIcon />,
		id: 'delete'
	}
];

const CUSTOM_DATASET_CREATE_PLACEHOLDER = {
	cardTitle: CUSTOM_DATASET_DEFAULT_TITLE,
	cardDesc: CUSTOM_DATASET_DEFAULT_DESC,
	templateId: CUSTOM_DATASET_ID
};

export const CustomTemplateMain = ({
	searchDatasetText,
	templateData,
	selectedCustomDataset,
	isEditMode = false,
	onModalClose = () => {}
}) => {
	const maxMeduimScreen = useMediaQuery('(max-width:1024px)');
	const minMeduimScreen = useMediaQuery('(min-width: 768px)');
	const classes = Styles({ maxMeduimScreen, minMeduimScreen });
	const dispatch = useDispatch();
	const [showSelectorModal, setShowSelectorModal] = useState(() => (isEditMode ? true : false));
	const [isCardEditMode, setIsCardEditMode] = useState(false);
	const [cardsList, setCardsList] = useState([]);
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails } = portalUserContext;
	const { userPersona, blackOut } = userDetails?.result;
	const navigate = useNavigate();
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const sbuDepartments = useSelector((state) => state.templateReducer.sbuDepartments);
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const customDatasetDetails = useSelector((state) => state.templateReducer.customDatasetDetails);
	const savedCustomDatasets = useSelector((state) => state.templateReducer.savedCustomDatasets);
	const isDeleteCustomDatasetSuccess = useSelector(
		(state) => state.templateReducer.isDeleteCustomDatasetSuccess
	);
	const { CDTourStepIndex } = useSelector((state) => state.tourReducer);
	// const savedDatasetList = useRef(dummyData);
	const [dialogHeaderComponent, setDialogHeaderComponent] = useState();
	const [dialogActionsComponent, setDialogActionsComponent] = useState();
	const [selectedCustomTemplate, setSelectedCustomTemplate] = useState(() =>
		isEditMode ? selectedCustomDataset : undefined
	);
	const [openSnackbar, setSnackbar] = useState({ open: false, msg: '' });
	const [showRenameDataset, setShowRenameDataset] = useState(false);
	const [showDeleteDatasetModal, setShowDeleteDatasetModal] = useState(false);
	const [anchorElement, setAnchorElement] = useState();
	const anchorElementCardDetails = useRef();
	const CDTourEnabled = localStorage.getItem(CDTourFlag) !== 'true';

	const savedCustomDatasetsNames = useMemo(() => {
		return (savedCustomDatasets ?? []).map((dataset) => dataset.customDatasetName);
	}, [savedCustomDatasets]);

	useEffect(() => {
		if (CDTourStepIndex === 1) {
			triggerCreateEditTemplate(CUSTOM_DATASET_CREATE_PLACEHOLDER);
		}
	}, [CDTourStepIndex]);

	useEffect(() => {
		if (isDeleteCustomDatasetSuccess && !openSnackbar.open) {
			setSnackbar({ open: true, msg: DELETE_SUCCESSFUL, type: 'dark', hideDuration: 3000 });
			dispatch(resetCustomDatasetDeleteSuccess());
		}
	}, [isDeleteCustomDatasetSuccess]);

	const trackTriggerCreateClick = () => {
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: ACTION_ON.CUSTOM_DATASET_TRIGGER_CREATE_CLICK,
			location: PAGE_ID.TEMPLATES
		});
	};

	const triggerCreateEditTemplate = (item) => {
		if (isUnsavedCustomDataset(item.templateId)) {
			const hasCustomDatasetDetails = Object.keys(customDatasetDetails).length > 0;
			// Open the Modal only if custom dataset details was retrieved with data
			if (hasCustomDatasetDetails) {
				setSelectedCustomTemplate(item);
				setShowSelectorModal(true);
			}
		} else {
			const selectedTableObjects = customDatasetDetails.tablesInfo.filter((tableDetail) =>
				item.tables.includes(tableDetail.tableName)
			);

			const result = {
				sortOrder: 1,
				folderNames: [...(item?.tables ?? customDatasetDetails.tableNames)],
				templateId: item.templateId,
				dimensions: [],
				measures: [],
				filter: customDatasetDetails.filter,
				filterWeekly: customDatasetDetails.filterWeekly,
				filterWeeklyMultiWindow: customDatasetDetails.filterWeeklyMultiWindow,
				view: customDatasetDetails?.view ?? ABC,
				defaultFilters: customDatasetDetails?.defaultFilters
			};

			selectedTableObjects.forEach((selectedTable) => {
				if (selectedTable.dimensions) {
					result.dimensions = [...result.dimensions, ...selectedTable.dimensions];
				}
				if (selectedTable.measures) {
					result.measures = [...result.measures, ...selectedTable.measures];
				}
			});

			const isMod = isCustomDatasetModular(selectedTableObjects);

			if (!isMod) {
				result.time = customDatasetDetails?.time;
			}

			const index = templateData.findIndex((item) => item.templateId == result.templateId);
			if (index > -1) {
				const temp = [...templateData];
				temp.splice(index, 1);
				dispatch(getTempatesSuccess([...temp, result]));
			} else dispatch(getTempatesSuccess([...templateData, result]));

			dispatch(resetSubTempates());
			dispatch(
				setSelectedTemplate({
					templateId: result.templateId,
					view: result.view,
					filter: result.filter,
					filterWeekly: result.filterWeekly,
					filterWeeklyMultiWindow: result.filterWeeklyMultiWindow
				})
			);

			const dispatchFilterList = (list) => {
				dispatch(setFilterList(list));
				dispatch(setPrevFilterList(list));
			};

			const dispatchSelectedList = (list) => {
				dispatch(setSelectedList(list));
			};

			handleBuildReport(
				selectedTemplate,
				[result],
				userPersona,
				blackOut,
				sbuDBTechNames,
				sbuDepartments,
				selectedView,
				dispatchFilterList,
				dispatchSelectedList
			);

			dispatch(clearPreview([]));
			dispatch(resetDraft());
			dispatch(saveItemShareStatus({ prev: false, curr: false }));
			if (item?.cardTitle) {
				dispatch(setCustomDatasetName({ datasetName: item.cardTitle }));
			}
			// Analytics
			trackEventInfo({
				type: EVENTS.CLICK,
				actionOn: ACTION_ON.CUSTOM_DATASET_SELECTION,
				location: PAGE_ID.TEMPLATES
			});
			navigate('/preview');
		}
	};

	useEffect(() => {
		//api call to fetch custom templates and set REF
		addCustomCardToMyDataset();
		setAnchorElement(null);
	}, [savedCustomDatasets]);

	useEffect(() => {
		if (searchDatasetText && savedCustomDatasets) {
			const filteredList = savedCustomDatasets.filter((item) => {
				if (item.cardTitle.toLocaleLowerCase().includes(searchDatasetText.toLocaleLowerCase()))
					return item;
			});
			setCardsList(filteredList);
		} else addCustomCardToMyDataset();
	}, [searchDatasetText]);

	const handleMenuEvents = (item) => {
		const id = item.id;
		const fn = {
			delete: () => {
				setSelectedCustomTemplate(anchorElementCardDetails.current);
				setShowDeleteDatasetModal(true);
			},
			rename: () => {
				setSelectedCustomTemplate(anchorElementCardDetails.current);
				setShowRenameDataset(true);
			},
			edit: () => {
				setSelectedCustomTemplate(anchorElementCardDetails.current);
				setShowSelectorModal(true);
				setIsCardEditMode(true);
			}
		};
		return fn[id]();
	};

	const addCustomCardToMyDataset = () => {
		const listOfSavedTemplates = [...savedCustomDatasets];
		listOfSavedTemplates.unshift(CUSTOM_DATASET_CREATE_PLACEHOLDER);
		setCardsList([...listOfSavedTemplates]);
	};

	const getDialog = () => {
		const onClose = () => {
			setShowSelectorModal(false);
			setIsCardEditMode(false);
			onModalClose();
		};
		const onCloseModalFn = (bool) => {
			if (bool === false) {
				setSelectedCustomTemplate(undefined);
				onClose();
			} else {
				setShowSelectorModal(true);
			}
		};

		return (
			<Dialog
				fullWidth={true}
				maxWidth={'md'}
				style={{ zIndex: 99 }}
				open={showSelectorModal}
				scroll={'paper'}
				onClose={onClose}>
				{dialogHeaderComponent && (
					<DialogTitle id="scroll-dialog-title">{dialogHeaderComponent}</DialogTitle>
				)}
				<DialogContent className={classes.dialogContentContainer}>
					<CustomTemplateModal
						setHeader={setDialogHeaderComponent}
						setActions={setDialogActionsComponent}
						closeModalFn={onCloseModalFn}
						selectedCustomTemplate={selectedCustomTemplate}
						templateData={templateData}
						isEditMode={isEditMode || isCardEditMode}
						selectedTables={selectedCustomTemplate?.tables?.map((name) => ({
							name: name,
							checked: true
						}))}
					/>
				</DialogContent>
				{dialogActionsComponent && (
					<DialogActions
						id="custom-dataset-dialog-actions"
						classes={{ root: classes.dialogActionsContainer }}>
						{dialogActionsComponent}
					</DialogActions>
				)}
			</Dialog>
		);
	};

	const isDuplicateName = (datasetName) => {
		return savedCustomDatasetsNames.some(
			(name) => name?.toLowerCase().trim() === datasetName?.toLowerCase()?.trim()
		);
	};

	const hideSnackbar = () => {
		if (openSnackbar.open) {
			setSnackbar({ open: false, msg: '', guidedBtn: false });
		}
	};

	const updateTemplateName = (oldName, newName) => {
		const existingDataset = savedCustomDatasets.find((ele) => ele.customDatasetName === oldName);
		if (!existingDataset) {
			console.error(`No custom dataset found with name: ${oldName}`);
			return;
		}
		let newDataset = deepClone(existingDataset);
		newDataset['customDatasetName'] = newName;
		//Note: For now, before we update the cardTitle using backend returned data, the customDatasetName will be new name and cardTitle will be oldName
		dispatch(updateCustomDataset(newDataset));
		setShowSelectorModal(false);
	};

	if (isEditMode) {
		return getDialog();
	}

	return (
		<div className={classes.gridContainer}>
			<div>
				<Grid container spacing={3}>
					{/* Tour guide starter */}
					{CDTourEnabled && <FtUXInitBox />}
					{cardsList &&
						deepClone(cardsList)
							.sort((a, b) => {
								return new Date(a?.datasetCreationDate) - new Date(b?.datasetCreationDate);
							})
							.map((item, index) => (
								<Grid
									item
									xs={12}
									sm={12}
									md={6}
									lg={4}
									key={index}
									className={classes.minWidthCard}>
									<Card
										id={`template_${item.templateId}`}
										variant="outlined"
										key={index}
										role="button"
										tabIndex={0}
										onKeyDown={() => {}}
										onClick={() => {
											trackTriggerCreateClick(item);
											triggerCreateEditTemplate(item);
										}}
										className={classes.inActiveBorder}>
										<Box className={classes.itemContainer}>
											<Box
												style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
												<img
													className={classes.spotIconCls}
													src={item.templateId == -1 ? addIcon : personIcon}
													alt="spot-icon"></img>
												{item.templateId !== -1 && (
													<div>
														<IconButton
															id="metadata-more"
															aria-label="metadata-more"
															size="small"
															className={classes.crossButton}
															onClick={(e) => {
																e.stopPropagation();
																setSelectedCustomTemplate(item);
																anchorElementCardDetails.current = item;
																setAnchorElement(e.currentTarget);
															}}>
															<MoreHorizIcon fontSize="small" />
														</IconButton>
													</div>
												)}
											</Box>
											<Box className={classes.myDatasetCardContent}>
												<Typography className={classes.myDatasetCardTitle}>
													{item.cardTitle}
												</Typography>
												{item.templateId !== -1 && (
													<Typography className={classes.myDatasetCreator}>
														{CUSTOM_CREATOR_PLACEHOLDER}
													</Typography>
												)}
												{/* Charter only or Enhanced tag */}
												<Tag item={item} />
											</Box>
											<Typography className={classes.myDatasetCardDesc}>{item.cardDesc}</Typography>
										</Box>
									</Card>
								</Grid>
							))}
				</Grid>
			</div>
			<br />
			{getDialog()}

			<MenuItemsList
				optionsList={CUSTOM_TEMPLATE_CARD_OPTIONS_LIST}
				anchorEl={anchorElement}
				handleEvents={handleMenuEvents}
				setAnchorEl={setAnchorElement}
			/>
			{showRenameDataset && (
				<SaveDatasetModel
					isEditMode={true}
					previousName={selectedCustomTemplate?.cardTitle}
					isDuplicateName={isDuplicateName}
					onDontSave={() => setShowRenameDataset(false)}
					open={showRenameDataset}
					onClose={() => setShowRenameDataset(false)}
					onSaveModal={(newName) => {
						updateTemplateName(selectedCustomTemplate?.cardTitle, newName);
						setShowRenameDataset(false);
						trackEventInfo({
							type: EVENTS.CLICK,
							actionOn: ACTION_ON.CUSTOM_DATASET_RENAME,
							location: PAGE_ID.TEMPLATES
						});
					}}
				/>
			)}
			{showDeleteDatasetModal && (
				<DeleteDatasetModal
					open={showDeleteDatasetModal}
					closeModalFn={setShowDeleteDatasetModal}
					selectedDataset={selectedCustomTemplate}
				/>
			)}
			<RBSnackbar
				doOpen={openSnackbar.open}
				msg={openSnackbar.msg}
				doClose={hideSnackbar}
				guidedBtn={openSnackbar.guidedBtn}
				type={openSnackbar.type}
			/>
		</div>
	);
};
